import "core-js/modules/es.array.push.js";
import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.for-each.js";
export default {
  props: {
    visible: {
      type: Boolean,
      default: false,
      required: true
    },
    info: Array
  },
  watch: {
    visible(newV) {
      if (newV == true) {
        this.getData();
      }
      this.previewVisible = newV;
    }
  },
  data() {
    return {
      previewVisible: false,
      list: []
    };
  },
  methods: {
    getData() {
      let list = [];
      this.info.forEach(item => {
        list.push({
          type: item.type,
          child: []
        });
      });
      this.list = list.filter((item, i, self) => {
        return self.findIndex(t => JSON.stringify(t) === JSON.stringify(item)) === i;
      });
      this.list.forEach(type => {
        this.info.forEach(item => {
          if (item.type == type.type) {
            type.child.push(item);
          }
        });
      });
      // console.log(this.list);
    },
    closeAdd() {
      this.$emit('cancel');
    }
  }
};